<template>
  <p class="text-sm text-muted-foreground">
    <slot></slot>
  </p>
</template> 